// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/views/Blog/BlogTeaser.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/views/Blog/BlogTeaser.tsx");
  import.meta.hot.lastModified = "1773385375630.6357";
}
// REMIX HMR END

import { Image } from "@unpic/react";
import clsx from "clsx";
import Heading from "~/components/Heading";
import IconResolver from "~/components/IconResolver";
import Link from "~/components/Link";
import { formatDate } from "~/utils/utils";
const variantStyles = {
  full: {
    articleStyles: "col-span-full gap-4 lg:gap-8 flex-col lg:flex-row",
    linkStyles: "shrink-0 self-start",
    imageStyles: "object-cover h-full lg:w-[595px] lg:h-[356px]",
    titleStyles: "text-3xl font-semibold",
    summaryStyles: "mb-auto"
  },
  card: {
    articleStyles: "w-full col-span-full md:col-span-1 gap-4 flex-col",
    imageStyles: "h-auto object-cover",
    titleStyles: "text-xl font-semibold",
    summaryStyles: "md:mb-auto !text-base"
  },
  blog: {
    articleStyles: "gap-4 md:gap-8 flex-col xl:flex-row",
    imageStyles: "",
    titleStyles: "text-xl font-semibold",
    summaryStyles: "md:mb-auto"
  },
  blogToc: {
    articleStyles: "flex justify-center flex-col",
    imageStyles: "mx-auto mb-8",
    titleStyles: "text-xl font-semibold",
    summaryStyles: "md:mb-auto"
  }
};
export default function BlogTeaser({
  item: {
    image,
    title,
    path,
    abstract,
    author,
    created
  },
  variant
}) {
  const {
    articleStyles,
    imageStyles,
    titleStyles,
    summaryStyles
  } = variantStyles[variant];
  if (variant === "blog") {
    return <div className="mt-8">
        <div className={clsx("flex items-center xl:items-stretch text-neutral-500", articleStyles)}>
          <Image layout="constrained" width={543} height={680} priority={false} background="neutral-200" src={image?.mediaImage.url} alt={image?.mediaImage.alt ?? title} className={clsx("object-cover", imageStyles)} />
          <div className="p-8 w-full h-auto text-neutral-600 bg-neutral-100 border border-neutral-300 rounded-md" dangerouslySetInnerHTML={{
          __html: abstract
        }} />
        </div>
      </div>;
  }
  if (variant === "blogToc") {
    return <div className="flex items-center">
        <div className={clsx("text-neutral-500", articleStyles)}>
          <Image layout="constrained" width={543} height={680} priority={false} background="neutral-200" src={image?.mediaImage.url} alt={image?.mediaImage.alt ?? title} className={clsx("object-cover", imageStyles)} />
          <div className="p-8 w-full h-auto text-neutral-600 bg-neutral-100 border border-neutral-300 rounded-md" dangerouslySetInnerHTML={{
          __html: abstract
        }} />
        </div>
      </div>;
  }
  return <article className={clsx("flex items-center text-neutral-600", articleStyles)}>
      <Image layout="constrained" width={343} height={400} priority={false} background="neutral-200" src={image?.mediaImage.url} alt={image?.mediaImage.alt ?? title} className={clsx("w-full rounded-md", imageStyles)} />
      <div className="w-full h-full flex flex-col justify-start">
        <Heading tag="h2" className={titleStyles}>
          {title}
        </Heading>
        <span className="mb-4 font-semibold">{`By ${author?.fullName}, ${formatDate(created?.timestamp)}`}</span>
        <p className={clsx("w-full text-lg mb-8 font-normal", summaryStyles)}>
          {abstract}
        </p>
        <div className="w-full pt-4 flex items-center flex-wrap gap-2 justify-end">
          {path && <Link prefetch="intent" className="flex w-fit items-center" to={path}>
              <span>Read Post</span>
              <IconResolver className="w-6 h-6" token="chevron-right" />
            </Link>}
        </div>
      </div>
    </article>;
}
_c = BlogTeaser;
var _c;
$RefreshReg$(_c, "BlogTeaser");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;